import constants from '../services/constants';
import { atom } from 'recoil';

const reloadActiveIssueTimelineAtom = atom<boolean>({
    key: constants.reloadActiveIssueTimelineAtom,
    default: false,
});

export default reloadActiveIssueTimelineAtom;